(() => {
  'use strict';
  if (window.mrTourSiteShell) return;
  window.mrTourSiteShell = true;
  const wrapper = document.querySelector('.mr-global-menu');
  const header = wrapper?.querySelector('.site-header');
  if (!header) return;
  const desktop = window.matchMedia('(min-width: 1200px)');
  const touch = window.matchMedia('(hover: none)');
  const overlay = wrapper.classList.contains('is-light');
  let stuck = false;
  let frame = 0;
  let transitionTimer;
  if (header.dataset.sticky === 'true') {
    const spacer = document.createElement('div');
    spacer.className = 'site-header-sticky';
    header.before(spacer);
    spacer.append(header);
    const resize = () => { spacer.style.height = `${header.getBoundingClientRect().height}px`; };
    const sync = () => {
      frame = 0;
      const threshold = desktop.matches ? (stuck ? 16 : 64) : 250;
      const next = window.scrollY > threshold;
      if (next === stuck) return;
      stuck = next;
      clearTimeout(transitionTimer);
      header.classList.toggle('site-header--stuck', stuck);
      header.classList.remove('site-header--opening');
      if (overlay) wrapper.classList.toggle('is-light', !stuck);
      if (stuck) transitionTimer = setTimeout(() => header.classList.add('site-header--opening'), 100);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(sync); };
    resize();
    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(header);
    else window.addEventListener('resize', resize, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    desktop.addEventListener('change', schedule);
    sync();
  }
  const dropdowns = [...header.querySelectorAll('.site-nav--has-dropdown, .site-nav__deep-dropdown-trigger')];
  const setOpen = (item, open) => {
    item.classList.toggle('is-focused', open);
    item.querySelector(':scope > a')?.setAttribute('aria-expanded', String(open));
  };
  const closeDropdowns = () => dropdowns.forEach(item => setOpen(item, false));
  dropdowns.forEach(item => {
    const link = item.querySelector(':scope > a');
    if (!link) return;
    link.setAttribute('aria-expanded', 'false');
    item.addEventListener('mouseenter', () => { if (!touch.matches) setOpen(item, true); });
    item.addEventListener('mouseleave', () => {
      if (!item.contains(document.activeElement)) setOpen(item, false);
    });
    item.addEventListener('focusin', () => setOpen(item, true));
    item.addEventListener('focusout', event => {
      if (!item.contains(event.relatedTarget)) setOpen(item, false);
    });
    let wasOpen = false;
    link.addEventListener('pointerdown', () => { wasOpen = item.classList.contains('is-focused'); });
    link.addEventListener('click', event => {
      if (!touch.matches || event.detail === 0 || wasOpen) return;
      event.preventDefault();
      dropdowns.forEach(other => {
        if (other !== item && !other.contains(item)) setOpen(other, false);
      });
      setOpen(item, true);
    });
  });
  document.addEventListener('click', event => { if (!header.contains(event.target)) closeDropdowns(); });
  const announcement = wrapper.querySelector('.announcement');
  const announcementClose = announcement?.querySelector('.announcement__close');
  const announcementText = announcement?.querySelector('.announcement__text');
  if (announcementClose && announcementText) {
    const key = announcementText.dataset.text;
    let dismissed = false;
    try { dismissed = sessionStorage.getItem(key) === 'hidden'; } catch {}
    const sizeAnnouncement = () => {
      announcement.style.maxHeight = `${announcementText.getBoundingClientRect().height}px`;
    };
    if (!dismissed) setTimeout(() => {
      announcement.classList.remove('announcement--closed');
      sizeAnnouncement();
      announcement.classList.add('announcement--opening');
    }, 2000);
    if ('ResizeObserver' in window) new ResizeObserver(sizeAnnouncement).observe(announcementText);
    else window.addEventListener('resize', sizeAnnouncement, { passive: true });
    announcementClose.addEventListener('click', event => {
      event.preventDefault();
      try { sessionStorage.setItem(key, 'hidden'); } catch {}
      announcement.classList.add('announcement--closed');
    });
  }
  const search = header.querySelector('.site-header__search-container');
  let searchTrigger;
  const closeSearch = () => {
    if (!search?.classList.contains('is-active')) return;
    search.classList.remove('is-active');
    [document.documentElement, document.body].forEach(el => el.classList.remove('js-drawer-open', 'js-drawer-open--search'));
    searchTrigger?.setAttribute('aria-expanded', 'false');
    searchTrigger?.focus();
  };
  header.querySelectorAll('.js-search-header').forEach(trigger => {
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', event => {
      if (!search) return;
      event.preventDefault();
      searchTrigger = trigger;
      search.classList.add('is-active');
      [document.documentElement, document.body].forEach(el => el.classList.add('js-drawer-open', 'js-drawer-open--search'));
      trigger.setAttribute('aria-expanded', 'true');
      search.querySelector('input[type="search"]')?.focus();
    });
  });
  search?.querySelector('.js-search-header-close')?.addEventListener('click', closeSearch);
  document.querySelector('#MainContent')?.addEventListener('click', closeSearch);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeSearch();
      closeDropdowns();
    }
    if (event.key === 'Tab') {
      document.documentElement.classList.add('tab-outline');
      if (!search?.classList.contains('is-active')) return;
      const controls = [...search.querySelectorAll('input:not([type="hidden"]), button, a[href]')].filter(el => !el.disabled && el.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    }
  });
  if ('ontouchstart' in window || navigator.maxTouchPoints > 0) document.body.classList.add('supports-touch');
})();
